import {
  CreateQuestion,
  DeleteQuestion,
  UpdatetQuestion,
  getForms,
  getQuestion,
  getVisibilityOptions,
} from "@/api/forms-questions/forms-questions-services";

export const formsQuestionsSlice = (set, get) => ({
  views: [],
  updateModal: false,
  questionToUpdateData: {},
  refreshQuestions: null,

  setRefreshQuestions: (callback) => {
    set({ refreshQuestions: callback });
  },

  getVisibilityOptions: async () => {
    const data = await getVisibilityOptions();
    set({ views: data });
    return data;
  },

  createQuestion: async (questionData, formType) => {
    const allForms = await getForms();
    const form = allForms.find((form) => form.type === formType);
    if (!form) {
      throw new Error(`No se encontró el formulario de tipo: ${formType}`);
    }
    // Asegurar que el ID del formulario esté incluido
    const dataToSend = {
      form_id: form.id,
      ...questionData,
    };
    await CreateQuestion(dataToSend, form.id);
    
    // Llamar a refreshQuestions para actualizar la interfaz
    const refreshFn = get().refreshQuestions;
    if (refreshFn) {
      refreshFn();
    }
  },

  deleteQuestion: async (id) => {
    try {
      const result = await DeleteQuestion(id);
      
      // Llamar a refreshQuestions para actualizar la interfaz
      const refreshFn = get().refreshQuestions;
      if (refreshFn) {
        refreshFn();
      }
      
      return result;
    } catch (error) {
      console.error("Error al eliminar la pregunta:", error);
      throw error;
    }
  },

  setUpdateModal: (value) => {
    set((state) => ({
      updateModal: value,
      questionToUpdateData: value ? state.questionToUpdateData : {},
    }));
  },

  getQuestionToUpdateData: async (id) => {
    const data = await getQuestion(id);
    set({ questionToUpdateData: data });
    return data;
  },

  UpdatetQuestion: async (id, questionData, formType) => {
    try {
      const allForms = await getForms();
      const form = allForms.find((form) => form.type === formType);
      if (!form) {
        throw new Error(`No se encontró el formulario de tipo: ${formType}`);
      }
      
      // Asegurar que el ID del formulario esté incluido
      const dataToSend = {
        ...questionData,
        form_id: form.id,
      };
      
      const resultado = await UpdatetQuestion(id, dataToSend, form.id);
      
      // Llamar a refreshQuestions para actualizar la interfaz
      const refreshFn = get().refreshQuestions;
      if (refreshFn) {
        refreshFn();
      }
      
      return resultado;
    } catch (error) {
      console.error("Error en UpdatetQuestion:", error);
      throw error;
    }
  },
});
